document.addEventListener("DOMContentLoaded", () => {

  // --- SCHOOL COUNTRY GUARD ---
  function getSchoolCountry() {
    const school = window.currentSchool || {};
    if (school.country) return String(school.country).trim().toUpperCase();
    const stored = String(localStorage.getItem("yoc_school_country") || "").trim().toUpperCase();
    if (stored === "CA" || stored === "US") return stored;
    return "US";
  }

  const schoolCountry = getSchoolCountry();
  if (schoolCountry === "CA") {
    return;
  }

  let lastPayloadSignature = "";

  function getInputValue(names) {
    const keys = Array.isArray(names) ? names : [names];

    for (let i = 0; i < keys.length; i += 1) {
      const key = keys[i];
      const propertiesInput = document.querySelector(`input[name="properties[${key}]"]`);
      if (propertiesInput && String(propertiesInput.value || "").trim() !== "") {
        return propertiesInput.value;
      }

      const directInput = document.querySelector(`input[name="${key}"]`);
      if (directInput && String(directInput.value || "").trim() !== "") {
        return directInput.value;
      }
    }

    return "";
  }

  function checkAndUpdate() {

    const adSize = String(
      getInputValue('ad_size') ||
      document.querySelector('[data-online-ad-name]')?.value ||
      ""
    )
      .trim()
      .toLowerCase();

    // Always read from hidden inputs for redirect
    const firstName = getInputValue('_yoc_recipient_first_name');
    const lastName = getInputValue('_yoc_recipient_last_name');
    const grade = getInputValue('_yoc_recipient_grade');
    const businessName = getInputValue('_yoc_recipient_business_name');
    const nameListId = getInputValue('_nameListId');
    const urlParams = new URLSearchParams(window.location.search);
    const schoolOrderId = getInputValue('_school_order_Id');
    const currentSchool = window.currentSchool || {};
    const schoolName =
      getInputValue(['_school_name', 'School Name']) ||
      urlParams.get('_school_name') ||
      urlParams.get('School Name') ||
      String(currentSchool.name || currentSchool.school_name || '').trim() ||
      String(localStorage.getItem('yoc_school_name') || '').trim() ||
      '';
    const schoolCode =
      getInputValue(['_school_code', 'School Code']) ||
      urlParams.get('_school_code') ||
      urlParams.get('School Code') ||
      String(currentSchool.code || currentSchool.school_code || '').trim() ||
      String(localStorage.getItem('yoc_school_code') || '').trim() ||
      '';
    const adLayoutId = getInputValue('_ad_layout_id');

    const projectId =
      getInputValue(['_projectId', 'projectId', 'ProjectId']) ||
      urlParams.get('_projectId') ||
      urlParams.get('projectId') ||
      urlParams.get('ProjectId') ||
      '';
    const imageUrl = getInputValue('_imageurl');
    const sanitizedImageUrl = imageUrl && imageUrl !== 'undefined' ? imageUrl : '';

    const payload = {
      _yoc_recipient_first_name: firstName,
      _yoc_recipient_last_name: lastName,
      _yoc_recipient_grade: grade,
      _yoc_recipient_business_name: businessName,
      _nameListId: nameListId,
      _school_order_Id: schoolOrderId,
      'School Name': schoolName,
      'School Code': schoolCode,
      _ad_layout_id: adLayoutId,
      ad_size: adSize,
      _imageurl: sanitizedImageUrl,
    };

    const payloadSignature = JSON.stringify({
      ...payload,
      _resolved_project_id: projectId,
    });
    if (payloadSignature === lastPayloadSignature) return;
    lastPayloadSignature = payloadSignature;

    const cleanPayload = {};
    Object.keys(payload).forEach((key) => {
      if (payload[key]) cleanPayload[key] = payload[key];
    });
    if (projectId) {
      cleanPayload._projectId = projectId;
    }
    const params = new URLSearchParams(cleanPayload);

    let nextProductUrl = "/cart";

    if (!adSize || !adSize.includes("sixteenth")) {
      const cleanParams = new URLSearchParams(params);
      cleanParams.delete('_projectId');

      const projectIdParam = projectId ? encodeURIComponent(projectId) : '{ProjectId}';
      nextProductUrl = `/products/ad-print?projectId=${projectIdParam}`;

      if (cleanParams.toString()) {
        nextProductUrl += `&${cleanParams.toString()}`;
      }
    }

    document.body.dispatchEvent(
      new CustomEvent("mediaclipCustomizeButtonReady", {
        detail: { nextProductUrl },
      })
    );
  }


checkAndUpdate(); // run once on load

document.addEventListener("input", checkAndUpdate);
document.addEventListener("change", checkAndUpdate);

});